export default __webpack_public_path__ + "static/media/362.9b4a09da.gif";